<template>
  <div>
    <b-row>
      <b-col cols="4">
        <b-form-group label="CNPJ/CPF:">
          <Cnpj
            v-model="beneficio.cnpj"
            placeholder="CNPJ"
            :state="validateState('cnpj')"
            :allow_cpf="true"
          />
          <b-form-invalid-feedback>
            <span v-if="!$v.beneficio.cnpj.cnpj">
              <span v-if="beneficio.cnpj.length <= 11">CPF inválido</span>
              <span v-else>CNPJ inválido</span>
            </span>
            <span v-else>CNPJ é obrigatório</span>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Beneficiário:">
          <b-form-input
            v-model="beneficio.beneficiario"
            placeholder="Nome"
            :state="validateState('beneficiario')"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="4">
        <b-form-group label="Valor de repasse:">
          <NumberFormat
            v-model="beneficio.repasse"
            placeholder="Valor de repasse"
            :state="validateState('repasse')"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Município:">
          <SelectMunicipio
            v-model="beneficio.cidade_id"
            ref="selectMunicipio"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import SelectMunicipio from "@/modules/municipios/Components/SelectMunicipio";
import NumberFormat from "@/components/Form/NumberFormat.vue";
import Cnpj from "@/components/Form/Cnpj.vue";
import { cnpj, cpf } from "cpf-cnpj-validator";

export default {
  mixins: [validationMixin],
  components: { SelectMunicipio, NumberFormat, Cnpj },
  props: {
    value: {},
  },
  data: () => ({
    beneficio: {
      repasse: "",
      cnpj: "",
      beneficiario: "",
      cidade_id: "",
    },
  }),
  validations: {
    beneficio: {
      repasse: {
        required,
      },
      cnpj: {
        cnpj: (value) => {
          return !value || cnpj.isValid(value) || cpf.isValid(value);
        },
      },
      beneficiario: {},
      cidade: {},
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.beneficio[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.beneficio.$touch();
      return !this.$v.beneficio.$anyError;
    },
    save() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });

        return null;
      }
      return this.beneficio;
    },
  },
  watch: {
    "beneficio.cidade_id": {
      deep: true,
      handler: function (value, old) {
        if (value != old) {
          this.beneficio.cidade = this.$refs["selectMunicipio"].municipio;
        }
      },
    },
  },
  created() {
    if (this.value) {
      this.beneficio = JSON.parse(JSON.stringify(this.value));
    }
  },
};
</script>

<style>
</style>
